import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    SHIPMENTTIMELINEEVENTS_FEATURE_KEY,
    State,
    ShipmentTimelineEventsPartialState,
    shipmentTimelineEventsAdapter,
} from './shipment-timeline-events.reducer';

// Lookup the 'ShipmentTimelineEvents' feature state managed by NgRx
export const getShipmentTimelineEventsState = createFeatureSelector<
    ShipmentTimelineEventsPartialState,
    State
>(SHIPMENTTIMELINEEVENTS_FEATURE_KEY);

const {
    selectAll,
    selectEntities,
} = shipmentTimelineEventsAdapter.getSelectors();

export const getShipmentTimelineEventsLoading = createSelector(
    getShipmentTimelineEventsState,
    (state: State) => state.loading
);

export const getShipmentTimelineEventsError = createSelector(
    getShipmentTimelineEventsState,
    (state: State) => state.error
);

export const getAllShipmentTimelineEvents = createSelector(
    getShipmentTimelineEventsState,
    (state: State) => selectAll(state)
);

export const getShipmentTimelineEventsEntities = createSelector(
    getShipmentTimelineEventsState,
    (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
    getShipmentTimelineEventsState,
    (state: State) => state.selectedId
);

export const getSelected = createSelector(
    getShipmentTimelineEventsEntities,
    getSelectedId,
    (entities, selectedId) => selectedId && entities[selectedId]
);
